<template>
  <nav
    class="navbar navbar-expand-lg fixed-top"
    :class="isSticky ? 'sticky-white-nav' : 'top-nav'"
  >
    <div class="container-fluid">
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
        style="box-shadow: none"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <router-link class="navbar-brand logo-style" to="/">
        <img
          src="@/assets/umi-logo.png"
          alt="Bootstrap"
          width="85"
          height="37"
          class="d-inline-block align-text-top"
        />
      </router-link>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
          <li
            class="nav-item"
            v-for="(item, index) in routerLinks"
            :key="index"
            :class="clickRouter == item.path ? 'navbar_bottom' : ''"
          >
            <router-link :to="item.path" v-slot="{ navigate }" custom>
              <a
                class="nav-link"
                :class="clickRouter == item.path ? 'active' : ''"
                @click="
                  (e) => {
                    e.preventDefault();
                    customNavigate(navigate, item.path);
                  }
                "
              >
                {{ item.name }}
              </a>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script setup>
import {
  onMounted,
  onBeforeUnmount,
  computed,
  reactive,
  ref,
  watch,
  nextTick,
} from "vue";
import { useRoute } from "vue-router";
import { useRouterStore } from "@/stores/router.js";
import throttle from "lodash/throttle";

const route = useRoute();
const routerStore = useRouterStore();

const clickRouter = computed(() => routerStore.routerName);
const { setRouterName } = routerStore;

const routerLinks = reactive([
  { name: "首页", path: "/" },
  { name: "AI推理平台", path: "/#section0" },
  { name: "边缘网络", path: "/#section1" },
  { name: "关于我们", path: "/about" },
  { name: "帮助中心", path: "/#section4" },
  { name: "下载中心", path: "/download-app" },
]);

// 是否显示 sticky 样式
const isSticky = ref(false);
const STICKY_SCROLL_TOP = 50;
const SECTION_TRIGGER_OFFSET = 120;

const getNavbarHeight = () => {
  const navbar = document.querySelector(".navbar");
  return navbar?.offsetHeight ?? 80;
};

const updateActiveNav = () => {
  if (window.location.pathname !== "/") {
    isSticky.value = true;
    setRouterName(window.location.pathname);
    return;
  }

  const scrollTop = window.scrollY || window.pageYOffset || 0;
  isSticky.value = scrollTop > STICKY_SCROLL_TOP;

  const currentLine = scrollTop + getNavbarHeight() + SECTION_TRIGGER_OFFSET;
  const sections = routerLinks
    .filter((item) => item.path.startsWith("/#"))
    .map((item) => {
      const element = document.getElementById(item.path.replace("/#", ""));
      return element
        ? {
            path: item.path,
            top: element.getBoundingClientRect().top + scrollTop,
          }
        : null;
    })
    .filter(Boolean);

  let currentPath = "/";
  sections.forEach((section) => {
    if (currentLine >= section.top) {
      currentPath = section.path;
    }
  });

  setRouterName(currentPath);
};

const handleScroll = throttle(updateActiveNav, 80);

onMounted(() => {
  nextTick(() => {
    updateActiveNav();
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);
    window.addEventListener("load", handleScroll);
  });
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", handleScroll);
  window.removeEventListener("resize", handleScroll);
  window.removeEventListener("load", handleScroll);
  handleScroll.cancel();
});

watch(
  () => route.fullPath,
  () => {
    nextTick(() => {
      updateActiveNav();
    });
  },
);

const customNavigate = (navigate, path) => {
  isSticky.value = path !== "/";

  nextTick(() => {
    navigate();
    setRouterName(path);
    requestAnimationFrame(() => {
      updateActiveNav();
    });
  });
};
</script>
<style scoped>
.navbar .container-fluid {
  padding-left: 260px;
  padding-right: 260px;
}

.navbar.sticky-white-nav {
  background-color: rgba(255, 255, 255, 1);
}
.navbar.top-nav a {
  color: #000;
}
.navbar.top-nav {
  background-color: rgba(255, 255, 255, 0.3);
}
.navbar:hover {
  background-color: white;
}
.navbar:hover a {
  color: #000;
}
.navbar.sticky-white-nav a {
  color: #000;
}
.nav-item {
  position: relative;
}
.nav-item::after {
  position: absolute;
  left: 0;
  bottom: -3px;
  right: 0;
  height: 4px;
  content: "";
  background-color: #007eff;
  border-radius: 4px;
  opacity: 0;
  transform: scaleX(0);
  transition:
    transform 0.4s,
    opacity 0.4s;
}
.navbar a {
  text-decoration: none;
  cursor: pointer;
}
.navbar_bottom::after {
  opacity: 1;
  transform: scaleX(1);
}

.navbar a {
  color: #fff;
}
.sys-nav-sub-wp {
  height: 0;
  overflow: hidden;
  transition: height 0.6s ease;
  left: 0;
  position: absolute;
  right: unset;
  top: 60px;
  width: 100%;
  z-index: 4;
  background: #fff;
}
.nav-item {
  margin: 0 50px;
  font-size: 14px;
}
.nav-item:hover .sys-nav-sub-wp {
  height: 190px;
  border-top: 1px solid #f4f5f7;
}

.active {
  color: #007eff !important;
  font-weight: 700 !important;
}
.sys-nav-sub-wp .sys-nav-sub a {
  display: inline-block;
  line-height: 24px;
  padding: 0;
  text-align: center;
  transition:
    color 0.3s,
    background-color 0.3s;
  position: relative;
  text-decoration: none;
}
.sys-nav-sub-wp .sys-nav-sub a img {
  width: 160px;
  height: 120px;
  margin: 20px 40px 0;
}
.sys-nav-sub-wp .sys-nav-sub a h4 {
  font-weight: 600;
  font-size: 14px;
  color: #000;
}
.sys-nav-sub-wp .sys-nav-sub a:after {
  content: " ";
  width: 1px;
  height: 120px;
  background: #f4f5f7;
  position: absolute;
  right: 0;
  top: 20px;
}
.logo-style {
  display: flex;
  align-items: center;
  color: #1f7bd6 !important;
  font-weight: 700;
}

@media (max-width: 1200px) {
  .navbar .container-fluid {
    padding-left: 40px;
    padding-right: 40px;
  }

  .nav-item {
    margin: 0 20px;
    font-size: 14px;
  }
}

@media (max-width: 992px) {
  .navbar .container-fluid {
    padding-left: 16px;
    padding-right: 16px;
  }

  .nav-item {
    margin: 0;
    font-size: 3.6vw;
  }

  .nav-link {
    padding: 2vw 0;
  }

  .nav-item::after {
    display: none;
  }
}
</style>
